import { render } from "./TerminosCondiciones.vue?vue&type=template&id=58d32854&scoped=true&ts=true"
import script from "./TerminosCondiciones.vue?vue&type=script&lang=ts"
export * from "./TerminosCondiciones.vue?vue&type=script&lang=ts"

import "./TerminosCondiciones.vue?vue&type=style&index=0&id=58d32854&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d32854"]])

export default __exports__